import React from 'react';

import { useAppSelector } from '../../hooks';
import { TooltipTextContent } from './common';

export function WorkLineTooltip(props: { guid: string }) {
  const workLine = useAppSelector((state) => state.layout.workLines[props.guid]);

  if (workLine == null) {
    console.warn('Unable to find work line for tooltip.');
    return null;
  }

  return <TooltipTextContent text={`Work Line ${workLine.name}`} />;
}
